import React from "react";
import { Tag } from "antd";
import { Clock, Bell, Edit, CheckCircle, FileText, Search, Folder, XCircle, AlertTriangle } from "lucide-react";
import moment from "moment";
import { formatControlInterno, getTypeAbbreviation } from "./calendarUtils";

const EventItem = ({ item, isOverlapping, hasOverlaps, handleItemClick }) => {
  const renderEvent = () => {
    if (item.Tipo === "visita") {
            return (
              <div
                className={`calendar-event calendar-event-visita ${isOverlapping ? "overlapping-event" : ""} ${hasOverlaps ? "has-overlaps" : ""} ${item.Status === 5 ? "cancelled-event" : ""}`}>
                <div className="event-content">
                  <Clock size={12} className="event-icon" />
                  {isOverlapping && <AlertTriangle size={10} style={{ color: "#f44336", marginRight: "2px" }} />}
                  <span className={`event-text ${item.Status === 5 ? "cancelled-ci" : ""}`}>{formatControlInterno(item.ControlInterno)}</span>
                  {item.Hora1 && item.Hora2 && (
                    <span className="event-time">
                      {moment(item.Hora1, "HH:mm").format("HH:mm")}-{moment(item.Hora2, "HH:mm").format("HH:mm")}
                    </span>
                  )}
                </div>
              </div>
            );
          } else {
            const tagInfo = {
              solicitud: { color: "blue", icon: <Bell size={12} /> },
              contrato: { color: "purple", icon: <Edit size={12} /> },
              listo: { color: "green", icon: <CheckCircle size={12} /> },
              emision: { color: "gold", icon: <FileText size={12} /> },
              revision1: { color: "cyan", icon: <Search size={12} /> },
              revision2: { color: "orange", icon: <Search size={12} /> },
              papeleria: { color: "lime", icon: <Folder size={12} /> },
              cancelacion: { color: "red", icon: <XCircle size={12} /> },
            };
            const { color, icon } = tagInfo[item.Tipo] || {};
      
                  return (
                    <div className={`calendar-tag calendar-tag-${item.Tipo} ${item.Status === 5 ? "cancelled-event" : ""}`}>
                      {icon}
                      <span style={{ fontWeight: "bold" }} className={item.Status === 5 ? "cancelled-ci" : ""}>{formatControlInterno(item.ControlInterno)}</span>
                      <span style={{ marginLeft: "auto" }}>{getTypeAbbreviation(item.Tipo)}</span>
                    </div>
      );
    }
  };

  return (
    <div
      className="calendar-event-wrapper"
      onClick={(e) => {
        e.stopPropagation();
        handleItemClick(item);
      }}
    >
      {renderEvent()}
    </div>
  );
};

export default EventItem;
